export default function googleApi() {
    const chunkSize = 5242880;
    const CLIENT_ID = "1044308803122-9rmeg1382bhea10r6125ffl90risma75.apps.googleusercontent.com";
    // const CLIENT_ID = "435459346677-8qh09ochgj816g1hqontaehn2833f3o6.apps.googleusercontent.com";
    const API_KEY = "AIzaSyAwHnv1dTJ1dKZ2sirqKWsRqjMg4MaF7fE";
    const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"];
    // const SCOPES = "https://www.googleapis.com/auth/drive";
    const SCOPES = "https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.metadata https://www.googleapis.com/auth/drive";

    var googleApi = {
        AuthManager: {},
        FileManager: {},
        PickerManager: {
            isLoaded: true,
            createFilePicker: function (callback) {
                if (googleApi.AuthManager.isSignedIn()) {
                    var token = googleApi.AuthManager.getAccessToken();

                    var docsView = new google.picker.DocsView().setIncludeFolders(true).setOwnedByMe(true);

                    var picker = new google.picker.PickerBuilder()
                        .addView(docsView)
                        .setOrigin(window.location.protocol + "//" + window.location.host)
                        .setOAuthToken(token)
                        .setDeveloperKey(API_KEY)
                        .setCallback(callback)
                        .build();

                    picker.setVisible(true);
                }
            },
            createFilePicker3: function (callback) {
                if (googleApi.AuthManager.isSignedIn()) {
                    var token = googleApi.AuthManager.getAccessToken();

                    var docsView = new google.picker.DocsView().setIncludeFolders(true).setOwnedByMe(true);

                    var picker = new google.picker.PickerBuilder()
                        .addView(docsView)
                        .setOrigin(window.location.protocol + "//" + window.location.host)
                        .setOAuthToken(token)
                        .setDeveloperKey(API_KEY)
                        .setCallback(callback)
                        .build();

                    return picker;
                }
            },
            createFolderPicker: function (callback) {
                if (googleApi.AuthManager.isSignedIn()) {
                    var token = googleApi.AuthManager.getAccessToken();

                    var docsView = new google.picker.DocsView(google.picker.ViewId.FOLDERS)
                        .setIncludeFolders(true)
                        .setOwnedByMe(true)
                        .setSelectFolderEnabled(true);

                    var picker = new google.picker.PickerBuilder()
                        .setTitle("Select a folder")
                        .addView(docsView)
                        .setOAuthToken(token)
                        .setDeveloperKey(API_KEY)
                        .setCallback(callback)
                        .build();

                    picker.setVisible(true);
                }
            },
        },
    };

    googleApi.loadClient = function () {
        return new Promise((resolve, reject) => {
            window.gapi?.load("client:auth2:picker", () => {
                console.log("gapi.loadClient");
                resolve();
            });
        });
    };

    googleApi.initClient = function () {
        return new Promise((resolve, reject) => {
            console.log(API_KEY, CLIENT_ID);
            window.gapi?.client
                .init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES,
                })
                .then(
                    () => {
                        console.log("gapi.initClient");
                        resolve();
                    },
                    (err) => {
                        console.log("gapi.initClient err");
                        reject(err);
                    }
                )
                .catch((err) => {
                    reject(err);
                    console.log("gapi.initClient err");
                });
        });
    };

    googleApi.AuthManager = {};

    googleApi.AuthManager.signIn = function () {
        return window.gapi?.auth2
            .getAuthInstance()
            .signIn()
            .then(function () {});
    };

    googleApi.AuthManager.signOut = function () {
        window.gapi?.auth2.getAuthInstance().signOut();
    };

    googleApi.AuthManager.isSignedIn = function () {
        return window.gapi?.auth2.getAuthInstance().isSignedIn.get();
    };

    googleApi.AuthManager.getAccessToken = function () {
        return window.gapi?.auth.getToken().access_token;
    };

    googleApi.FileManager = {};

    googleApi.FileManager.ApiURI = {
        STANDARD: "https://www.googleapis.com/drive/v3",
        LIST: "https://www.googleapis.com/drive/v3/files",
        GET: "https://www.googleapis.com/drive/v3/files/", //https://www.googleapis.com/drive/v3/files/{fileId}
        METADATA: "https://www.googleapis.com/drive/v3/files",
        UPLOAD: "https://www.googleapis.com/upload/drive/v3/files?uploadType=resumable",
        UPDATE: "https://www.googleapis.com/upload/drive/v3/files/",
        DELETE: "https://www.googleapis.com/drive/v3/files/", //https://www.googleapis.com/drive/v3/files/{fileId}
    };

    googleApi.FileManager.listFiles = function (args) {
        let q = args.q;
        let successCallback = args.success;
        let errorCallback = args.error;

        var option = {
            fields: "*",
            // q:'mimeType != "application/vnd.google-apps.folder"',
            // q: 'name contains ".emmx"'
        };
        if (!!q) {
            option.q = q;
        }
        window.gapi?.client.drive.files.list(option).then(
            function (response) {
                if (successCallback) {
                    successCallback(response);
                }
            },
            function (response) {
                if (errorCallback) {
                    errorCallback(response);
                }
            }
        );
    };

    googleApi.FileManager.getFile = function (args) {
        return new Promise((resolve, reject) => {
            let fileId = args.fileId;
            if (!fileId) {
                reject({
                    errorMessage: "need fileId",
                });
            }
            window.gapi?.client.drive.files
                .get({
                    fileId: fileId,
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };

    googleApi.FileManager.moveFile = function ({ fileId, newName }) {
        return new Promise((resolve, reject) => {
            window.gapi?.client.drive.files
                .update({
                    fileId: fileId,
                    name: newName,
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    resolve(err);
                });
        });
    };

    googleApi.FileManager.createFile = function ({ fileName, parent }) {
        return new Promise((resolve, reject) => {
            let name = fileName == null ? null : fileName;
            let parents = parent == null ? [] : [parent];
            let xhr = new XMLHttpRequest();
            xhr.open("POST", googleApi.FileManager.ApiURI.METADATA);
            xhr.setRequestHeader("Authorization", "Bearer " + googleApi.AuthManager.getAccessToken());
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onload = function () {
                resolve(xhr.response);
            };
            xhr.send(
                JSON.stringify({
                    name,
                    parents,
                })
            );
        });
    };

    googleApi.FileManager.uploadFile = function (args) {
        return new Promise((resolve, reject) => {
            let blob = args.blob;
            let fileName = args.fileName;
            let progressCallback = args.progress;
            let parentId = args.parentId;
            let thumb = args.thumb;
            if (!fileName) {
                fileName = "unname.eddx";
            }
            if (fileName.indexOf(".eddx") < 0) {
                fileName = fileName + ".eddx";
            }
            if (blob) {
                var fr = new FileReader();
                fr.fileName = fileName;
                fr.fileSize = blob.size;
                fr.fileType = blob.type;
                fr.onload = function () {
                    var fileName = this.fileName;
                    var fileSize = this.fileSize;
                    var fileType = this.fileType;
                    var buf = this.result;
                    var chunkpot = (function (chunkSize, fileSize) {
                        var chunkPot = {};
                        chunkPot.total = fileSize; //总数据大小
                        chunkPot.chunks = [];
                        if (fileSize > chunkSize) {
                            var numE = chunkSize; //一块数据大小
                            var endS = (function (f, n) {
                                //最后一块数据大小
                                var c = f % n;
                                if (c == 0) {
                                    return 0;
                                } else {
                                    return c;
                                }
                            })(fileSize, numE);
                            var repeat = Math.floor(fileSize / numE); //一共多少块满chunkSize大小的数据
                            for (var i = 0; i <= repeat; i++) {
                                //填充数据 循环repeat+1次 repeat次满chunkSize数据
                                var startAddress = i * numE; //数据填充起点
                                var c = {};
                                c.startByte = startAddress;
                                if (i < repeat) {
                                    //前repeat次填满chunkSize数据
                                    c.endByte = startAddress + numE - 1;
                                    c.numByte = numE;
                                    chunkPot.chunks.push(c);
                                } else {
                                    c.endByte = startAddress + endS - 1;
                                    c.numByte = endS;
                                    chunkPot.chunks.push(c);
                                }
                            }
                        } else {
                            var chunk = {
                                startByte: 0,
                                endByte: fileSize - 1,
                                numByte: fileSize,
                            };
                            chunkPot.chunks.push(chunk);
                        }
                        return chunkPot;
                    })(chunkSize, fileSize);
                    var uint8Array = new Uint8Array(buf);
                    var chunks = chunkpot.chunks.map(function (e) {
                        return {
                            data: uint8Array.slice(e.startByte, e.endByte + 1),
                            length: e.numByte,
                            range: "bytes " + e.startByte + "-" + e.endByte + "/" + chunkpot.total,
                        };
                    });

                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", googleApi.FileManager.ApiURI.UPLOAD);
                    xhr.setRequestHeader("Authorization", "Bearer " + googleApi.AuthManager.getAccessToken());
                    xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                    if (!parentId) {
                        xhr.send(
                            JSON.stringify({
                                mimeType: fileType,
                                name: fileName,
                                contentHints: {
                                    thumbnail: {
                                        image: thumb,
                                    },
                                },
                            })
                        );
                    } else {
                        xhr.send(
                            JSON.stringify({
                                mimeType: fileType,
                                name: fileName,
                                parents: [parentId],
                                contentHints: {
                                    thumbnail: {
                                        image: thumb,
                                    },
                                },
                            })
                        );
                    }
                    if (progressCallback) {
                        progressCallback({
                            loaded: "0",
                            total: chunks.length,
                            type: "progress",
                        });
                    }
                    xhr.onload = function () {
                        var doUpload = (function (e) {
                            var chunks = e.chunks;
                            var location = e.location;
                            var cnt = 0;
                            var end = chunks.length;
                            var temp = (function callback(cnt) {
                                if (progressCallback) {
                                    progressCallback({
                                        loaded: cnt,
                                        total: chunks.length,
                                        type: "progress",
                                    });
                                }
                                var e = chunks[cnt];
                                var xhr = new XMLHttpRequest();
                                xhr.open("PUT", location, true);
                                xhr.setRequestHeader("Content-Range", e.range);
                                xhr.send(e.data);
                                xhr.onloadend = function () {
                                    var status = xhr.status;
                                    cnt += 1;
                                    console.log("Uploading: " + status + " (" + cnt + " / " + end + ")");
                                    if (status == 308) {
                                        callback(cnt);
                                    } else if (status == 200) {
                                        console.log("Uploading Finish");
                                        if (progressCallback) {
                                            progressCallback({
                                                loaded: cnt,
                                                total: chunks.length,
                                                type: "finish",
                                            });
                                        }
                                        resolve(xhr.response);
                                    } else {
                                        console.log("Error: " + xhr.response);
                                        reject(xhr.response);
                                    }
                                };
                            })(cnt);
                        })({
                            location: xhr.getResponseHeader("location"),
                            chunks: chunks,
                        });
                    };
                    xhr.onerror = function () {
                        reject(xhr.response);
                    };
                };
                fr.readAsArrayBuffer(blob);
            }
        });
    };

    googleApi.FileManager.updateFile = function ({ blob, fileId, fileName, thumb, progress }) {
        blob = blob != null ? blob : null;
        fileId = fileId != null ? fileId : null;
        fileName = fileName != null ? fileName : null;
        let progressCallback = progress;
        if (!fileName) {
            fileName = "Untitled.emmx";
        }
        if (fileName.indexOf(".emmx") < 0) {
            fileName = fileName + ".emmx";
        }
        return new Promise((resolve, reject) => {
            if (blob) {
                var fr = new FileReader();
                fr.fileName = fileName;
                fr.fileSize = blob.size;
                fr.fileType = blob.type;
                fr.onload = function () {
                    var fileName = this.fileName;
                    var fileSize = this.fileSize;
                    var fileType = this.fileType;
                    var buf = this.result;
                    var chunkpot = (function (chunkSize, fileSize) {
                        var chunkPot = {};
                        chunkPot.total = fileSize; //总数据大小
                        chunkPot.chunks = [];
                        if (fileSize > chunkSize) {
                            var numE = chunkSize; //一块数据大小
                            var endS = (function (f, n) {
                                //最后一块数据大小
                                var c = f % n;
                                if (c == 0) {
                                    return 0;
                                } else {
                                    return c;
                                }
                            })(fileSize, numE);
                            var repeat = Math.floor(fileSize / numE); //一共多少块满chunkSize大小的数据
                            for (var i = 0; i <= repeat; i++) {
                                //填充数据 循环repeat+1次 repeat次满chunkSize数据
                                var startAddress = i * numE; //数据填充起点
                                var c = {};
                                c.startByte = startAddress;
                                if (i < repeat) {
                                    //前repeat次填满chunkSize数据
                                    c.endByte = startAddress + numE - 1;
                                    c.numByte = numE;
                                    chunkPot.chunks.push(c);
                                } else {
                                    c.endByte = startAddress + endS - 1;
                                    c.numByte = endS;
                                    chunkPot.chunks.push(c);
                                }
                            }
                        } else {
                            var chunk = {
                                startByte: 0,
                                endByte: fileSize - 1,
                                numByte: fileSize,
                            };
                            chunkPot.chunks.push(chunk);
                        }
                        return chunkPot;
                    })(chunkSize, fileSize);
                    var uint8Array = new Uint8Array(buf);
                    var chunks = chunkpot.chunks.map(function (e) {
                        return {
                            data: uint8Array.slice(e.startByte, e.endByte + 1),
                            length: e.numByte,
                            range: "bytes " + e.startByte + "-" + e.endByte + "/" + chunkpot.total,
                        };
                    });

                    var xhr = new XMLHttpRequest();
                    xhr.open("PATCH", "https://www.googleapis.com/upload/drive/v3/files/" + fileId + "?uploadType=resumable");
                    xhr.setRequestHeader("Authorization", "Bearer " + googleApi.AuthManager.getAccessToken());
                    xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                    xhr.send(
                        JSON.stringify({
                            mimeType: fileType,
                            name: fileName,
                            contentHints: {
                                thumbnail: {
                                    image: thumb,
                                },
                            },
                        })
                    );
                    if (progressCallback) {
                        progressCallback({
                            loaded: "0",
                            total: chunks.length,
                            type: "progress",
                        });
                    }
                    xhr.onload = function () {
                        var doUpload = (function (e) {
                            var chunks = e.chunks;
                            var location = e.location;
                            var cnt = 0;
                            var end = chunks.length;
                            var temp = (function callback(cnt) {
                                if (progressCallback) {
                                    progressCallback({
                                        loaded: cnt,
                                        total: chunks.length,
                                        type: "progress",
                                    });
                                }
                                var e = chunks[cnt];
                                var xhr = new XMLHttpRequest();
                                xhr.open("PUT", location, true);
                                xhr.setRequestHeader("Content-Range", e.range);
                                xhr.send(e.data);
                                xhr.onloadend = function () {
                                    var status = xhr.status;
                                    cnt += 1;
                                    console.log("Uploading: " + status + " (" + cnt + " / " + end + ")");
                                    if (status == 308) {
                                        callback(cnt);
                                    } else if (status == 200) {
                                        console.log("Uploading Finish");
                                        if (progressCallback) {
                                            progressCallback({
                                                loaded: cnt,
                                                total: chunks.length,
                                                type: "finish",
                                            });
                                        }
                                        resolve();
                                    } else {
                                        reject();
                                    }
                                };
                            })(cnt);
                        })({
                            location: xhr.getResponseHeader("location"),
                            chunks: chunks,
                        });
                    };
                    xhr.onerror = function () {
                        reject();
                    };
                };
                fr.readAsArrayBuffer(blob);
            }
        });
    };

    googleApi.FileManager.downloadFile = function ({ fileId, progress }) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", googleApi.FileManager.ApiURI.GET + fileId + "?alt=media");
            xhr.setRequestHeader("Authorization", "Bearer " + googleApi.AuthManager.getAccessToken());
            xhr.responseType = "blob";

            xhr.onprogress = function (response) {
                if (progress) {
                    progress(response);
                }
            };
            xhr.onload = function (response) {
                var content = xhr.response;
                resolve(content);
            };
            xhr.send();
        });
    };

    return googleApi;
}
